module.exports = __webpack_public_path__ + "static/media/guest.730af7ff.png";